import {
  RECIPIENT_CARD_SELECTED,
  REMOVE_INDIVIDUAL_MESSAGE,
  selectRecipientMessage,
  UPDATE_INDIVIDUAL_MESSAGE,
} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {selectEventId} from '~/common/fabric/EventGuests/reducers/guests/selectors';

export const addCustomRecipientMessage = (guestIds) => async (dispatch, getState) => {
  const state = getState();
  const eventId = selectEventId(state);
  const recipientMessages = guestIds.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: selectRecipientMessage(curr)(state),
    }),
    {}
  );

  const url = `/ajax/event/${eventId}/guestlist/add-custom-message/`;
  const token = window.evite.cookie('csrftoken');
  const headers = {
    'X-CSRFToken': token,
    accept: 'application/json',
    'Content-Type': 'application/json',
  };

  try {
    await evite.fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(recipientMessages),
    });
  } catch (err) {
    evite.error(`Error to save custom message: ${err.message}`);
  }
};

export const getCustomRecipientsMessage = () => async (dispatch, getState) => {
  const state = getState();
  const eventId = selectEventId(state);
  const url = `/ajax/event/${eventId}/guestlist/get-custom-message/`;
  const token = window.evite.cookie('csrftoken');
  const headers = {
    'X-CSRFToken': token,
    accept: 'application/json',
    'Content-Type': 'application/json',
  };

  try {
    const response = await evite.fetch(url, {
      method: 'GET',
      headers,
    });

    const json = await response.json();

    if (json) {
      // biome-ignore lint/correctness/noUnusedVariables: existing error
      const {data_layer: dataLayer, ...data} = json;
      dispatch({
        type: UPDATE_INDIVIDUAL_MESSAGE,
        payload: data,
      });
    }

    return json;
  } catch (err) {
    evite.error(`Error to get custom messages: ${err.message}`);
    return undefined;
  }
};

export const removeCustomRecipientMessage = (guestId) => async (dispatch, getState) => {
  const state = getState();
  const eventId = selectEventId(state);
  const url = `/ajax/event/${eventId}/guestlist/delete-custom-message/${guestId}/`;
  const token = window.evite.cookie('csrftoken');
  const headers = {
    'X-CSRFToken': token,
    accept: 'application/json',
    'Content-Type': 'application/json',
  };

  try {
    await evite.fetch(url, {
      method: 'DELETE',
      headers,
    });

    dispatch({type: RECIPIENT_CARD_SELECTED, payload: null});
    dispatch({type: REMOVE_INDIVIDUAL_MESSAGE, payload: guestId});
  } catch (err) {
    evite.error(`Error to delete custom message: ${err.message}`);
  }
};
